<template>
	<div class="list-page">
		<div class="list-page__header">
			<span>园区公告</span>
		</div>
		<div class="list-page__content">
			<div class="news-contanier-context">
				<router-link
					class="news-contanier-context-main"
					v-for="item in pageList.list"
					:key="item.id"
					:to="`/ParkDynamics/notice/${item.id}`"
					tag="div"
				>
					<div class="news-contanier-context-main-left">
						<img
							:src="item.img"
							:alt="item.title"
							class="imgText"
						/>
					</div>
					<div class="news-contanier-context-main-right">
						<p class="news-contanier-context-main-right-title">
							{{ item.title }}
						</p>
						<p class="news-contanier-context-main-right-content">
							{{ item.introduction }}
						</p>
						<span class="news-contanier-context-main-right-date">{{
							item.publishtime | formatDate
						}}</span>
					</div>
				</router-link>
			</div>
		</div>

		<div class="list-page__footer">
			<el-pagination
				@current-change="handleCurrentChange"
				:current-page.sync="pageList.pageNumber"
				:page-size="pageList.pageSize"
				layout="prev, pager, next, jumper"
				:total="pageList.totalRow"
			>
			</el-pagination>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
	props: {},
	data() {
		return {
			page: 1,
			limit: 10,
		}
	},
	computed: {
		...mapState('YQDT', ['pageList']),
	},
	mounted() {
		const params = {
			parkType: 2,
		}
		this.fetchPageList(params)
	},
	methods: {
		...mapActions('YQDT', ['fetchPageList', 'handleCurrentChange']),
	},
}
</script>

<style lang="scss">
.imgText {
  display: block;
	width: 300px;
	height: 170px;
}
.news-contanier {
	text-align: center;
	&-title {
		padding: 30px 0px;
		font-size: 28px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: rgba(0, 0, 0, 0.85);
		letter-spacing: 2px;
		border-bottom: 1px solid #f0f0f0;
	}
	&-context {
		padding: 30px 40px;
		&-main {
			display: flex;
			margin-bottom: 30px;
			&-right {
				padding: 0px 0px 10px 20px;
				text-align: left;
				&-title {
					font-size: 18px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #000000;
				}
				&-content {
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: rgba(0, 0, 0, 0.45);
					padding: 25px 0px 35px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					height: 88px;
					-webkit-line-clamp: 3;
					line-clamp: 3;
					-webkit-box-orient: vertical;
				}
				&-date {
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: rgba(0, 0, 0, 0.45);
				}
			}
		}
	}
}
</style>
